import modalHtml from './modalHtml';

items.create({
    name: 'speakerModal',
    modal: {
        selector: '[items-html-speaker]',
        name: 'speaker',
        data: (id, callback) => {
            $.get(route.speaker.show.replace('ID', id), callback, 'json');
        },
        html: modalHtml
    }
});